import { buildWomanImageAlt } from "../../../utils/imageAlt";
import { getWomanThumbImageUrl } from "../../../utils/imageUrl";

function WomenTab({
    women,
    categories,
    places,
    filters,
    pagination,
    loading,
    sortConfig,
    onFilterChange,
    onClearFilters,
    onSort,
    onAdd,
    onEdit,
    onDelete,
    onPageChange,
    onToggleMonthlyCandidate,
    monthlyCandidateUpdatingIds = [],
}) {
    const getSortIndicator = (field) => {
        const isActive = sortConfig.field === field;
        const arrow = isActive && sortConfig.direction === "desc" ? "▼" : "▲";
        return <span className={`admin__sort-arrow${isActive ? " active" : ""}`}>{arrow}</span>;
    };

    return (
        <div className="admin__section">
            <div className="admin__filters">
                <input
                    type="text"
                    placeholder="Caută după nume..."
                    value={filters.name}
                    onChange={(e) => onFilterChange("name", e.target.value)}
                />
                <select value={filters.category_id} onChange={(e) => onFilterChange("category_id", e.target.value)}>
                    <option value="">Toate categoriile</option>
                    {categories.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.name}
                        </option>
                    ))}
                </select>
                <select value={filters.place_id} onChange={(e) => onFilterChange("place_id", e.target.value)}>
                    <option value="">Toate locurile</option>
                    {places.map((p) => (
                        <option key={p.id} value={p.id}>
                            {p.name}
                        </option>
                    ))}
                </select>
                {(filters.name || filters.category_id || filters.place_id) && (
                    <button className="admin__clear-filters" onClick={onClearFilters}>
                        Șterge filtre
                    </button>
                )}
            </div>
            <button className="admin__add-btn" onClick={onAdd}>
                + Adaugă femeie
            </button>
            <table className="admin__table">
                <thead>
                    <tr>
                        <th className="admin__sortable" onClick={() => onSort("id")}>
                            ID {getSortIndicator("id")}
                        </th>
                        <th>Imagine</th>
                        <th className="admin__sortable" onClick={() => onSort("name")}>
                            Nume {getSortIndicator("name")}
                        </th>
                        <th className="admin__sortable" onClick={() => onSort("surname")}>
                            Prenume {getSortIndicator("surname")}
                        </th>
                        <th className="admin__sortable" onClick={() => onSort("category")}>
                            Categorie {getSortIndicator("category")}
                        </th>
                        <th className="admin__sortable" onClick={() => onSort("place")}>
                            Loc {getSortIndicator("place")}
                        </th>
                        <th title="Numărul de surse publicate pe profil">Surse</th>
                        <th>Femeia lunii</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
                                Se încarcă...
                            </td>
                        </tr>
                    ) : (
                        women.map((w) => (
                            <tr key={w.id}>
                                <td>{w.id}</td>
                                <td>
                                    <img
                                        src={getWomanThumbImageUrl(w.image)}
                                        alt={buildWomanImageAlt({
                                            name: w.name,
                                            surname: w.surname,
                                            category: w.category_name,
                                            place: w.place_name,
                                        })}
                                        className="admin__thumb"
                                    />
                                </td>
                                <td>{w.name}</td>
                                <td>{w.surname}</td>
                                <td>{w.category_name}</td>
                                <td>{w.place_name}</td>
                                <td>
                                    {(() => {
                                        const count = String(w.sources || "")
                                            .split("\n")
                                            .filter((line) => /https?:\/\//i.test(line)).length;

                                        return (
                                            <span
                                                className={`admin__sources-count ${count === 0 ? "admin__sources-count--none" : ""}`}>
                                                {count}
                                            </span>
                                        );
                                    })()}
                                </td>
                                <td className="admin__monthly-cell">
                                    <input
                                        type="checkbox"
                                        className="admin__monthly-checkbox"
                                        checked={parseInt(w.is_monthly_candidate || 0) === 1}
                                        disabled={monthlyCandidateUpdatingIds.includes(w.id)}
                                        aria-label={`Femeia lunii pentru ${w.name} ${w.surname}`}
                                        onChange={(e) => onToggleMonthlyCandidate(w.id, e.target.checked)}
                                    />
                                </td>
                                <td>
                                    <button onClick={() => onEdit(w)}>Editează</button>
                                    <button onClick={() => onDelete(w.id)} className="delete">
                                        Șterge
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            {pagination.totalPages > 1 && (
                <div className="admin__pagination">
                    <button disabled={pagination.page === 1} onClick={() => onPageChange(pagination.page - 1)}>
                        ← Anterior
                    </button>
                    <span>
                        Pagina {pagination.page} din {pagination.totalPages} ({pagination.total} total)
                    </span>
                    <button
                        disabled={pagination.page === pagination.totalPages}
                        onClick={() => onPageChange(pagination.page + 1)}>
                        Următorul →
                    </button>
                </div>
            )}
        </div>
    );
}

export default WomenTab;
